// Note: Types are properly inferred only for the first negation
export const not =
  <T>(fn: (x: unknown) => x is T) =>
  <U>(x: U): x is Exclude<U, T> =>
    !fn(x)
